import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Products, { ProductDetail } from './pages/Products'
import Documents, { DocumentDetail } from './pages/Documents'
import { Privacy, Terms } from './pages/Legal'
import About from './pages/About'
import FAQ from './pages/FAQ'
import { Articles, ArticleDetail } from './pages/Articles'
import { Cases, CaseDetail } from './pages/Cases'

export default function App() {
  return <Layout><Routes><Route path="/" element={<Home />} /><Route path="/about" element={<About />} /><Route path="/products" element={<Products />} /><Route path="/products/:id" element={<ProductDetail />} /><Route path="/documents" element={<Documents />} /><Route path="/documents/:id" element={<DocumentDetail />} /><Route path="/articles" element={<Articles />} /><Route path="/articles/:slug" element={<ArticleDetail />} /><Route path="/cases" element={<Cases />} /><Route path="/cases/:slug" element={<CaseDetail />} /><Route path="/faq" element={<FAQ />} /><Route path="/privacy" element={<Privacy />} /><Route path="/terms" element={<Terms />} /><Route path="*" element={<Home />} /></Routes></Layout>
}
